<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header">
              default header
            </slot>
          </div>

          <div
            v-if="body"
            class="modal-body"
          >
            <slot name="body">
              default body
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button
                class="btn btn-danger modal-default-button"
                @click="$emit('close',true)"
              >
                OK
              </button>
              <button
                class="btn btn-info modal-default-button"
                @click="$emit('close',false)"
              >
                Cancel
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>


<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 80%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
    margin: 20px 0;
    display: block;
    overflow-x: hidden;
    overflow-y: scroll;
    max-height: 61vh;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@media only screen and (max-width: 400px) {
  
  .modal-container{
      width: 360px;
      margin: 0;
  }
  .modal-header h1 {
      font-size: 20px !important;
  }
  .modal-body > h2{
      font-size: 20px;
  }
    
}

</style>

<script>
export default {
  name: 'ModalBasic',
  props: {
    body: {
      type: Boolean,
      default: true
    }
  }
}
</script>
